<div class="home-content">
  <section class="program" (click)="router.navigate(['/program'])">
    <div class="program__content">
      <h1 class="heading">Programm</h1>
      <div class="program__content--first">
        <img src="assets/images/Program1.jpg" alt="Looking persons art">
      </div>
      <div class="program__content--second">
        <img src="assets/images/Program2.jpg" alt="At cinema">
      </div>
    </div>
  </section>

  <section class="learning">
    <a href="https://moodle.bildungswerk-vielfalt.com" target="_blank">
      <div class="learning__content">
        <h1 class="heading">Lernplattform</h1>
        <div class="learning__content--first">
          <img src="assets/images/Lernplatform1.jpg" alt="Mens lying on the ground">
        </div>
        <div class="learning__content--second">
          <img src="assets/images/Lernplattform2.JPG" alt="Drawing images">
        </div>
      </div>
    </a>
  </section>

  <section class="educational" (click)="router.navigate(['/education'])">
    <div class="educational__content">
      <h1 class="heading">Beratung</h1>
      <div class="educational__content--first">
        <img src="assets/images/Bildungsberatung1.jpg" alt="Live singing">
      </div>
      <div class="educational__content--second">
        <img src="assets/images/Bildugnsbereatung2.JPG" alt="Live singing in front" class="crop">
      </div>
    </div>
  </section>

  <section class="projects" (click)="router.navigate(['/projects'])">
    <div class="projects__content">
      <h1 class="heading">Projekte</h1>
      <div class="projects__content--images">
        <div class="first-block">
          <div class="top-block">
            <div>
              <img src="assets/images/Projekte4.jpg" alt="">
            </div>
            <div>
              <img src="assets/images/Projekte3.jpg" alt="">
            </div>
          </div>
          <div>
            <img src="assets/images/Projekte5.JPG" alt="">
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="projects" (click)="router.navigate(['/demokratiewerkstatt'])">
    <div class="projects__content">
      <h1 class="heading padding">Demokratiewerkstatt</h1>
      <div class="projects__content--images">
        <div class="first-block">
          <div class="top-block">
            <div class="crop_image">
              <img src="assets/images/linkes_Bild_zur_Auswahl.jpg" alt="Zwei Personen im Gespräch in einer Werkstatt">
            </div>
            <div class="crop_image">
              <img src="assets/images/rechtes_bild.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="toolbox" (click)="router.navigate(['/toolbox-pages'])">
    <div class="toolbox__content">
      <div class="heading ">Toolbox</div>
      <div class="toolbox__content--images">
        <div class="toolbox--first-bock">
          <img src="assets/images/Toolbox.jpg" alt="">
        </div>
        <div class="toolbox--second-block">
          <div><img src="assets/images/Toolbox2.jpg" alt="Wemen in the sport room"></div>
        </div>
      </div>
    </div>
  </section>

  <section class="projects" (click)="router.navigate(['/programm/archiv'])">
    <div class="projects__content">
      <h1 class="heading padding">Programmarchiv</h1>
      <div class="projects__content--images">
        <div class="first-block">
          <div class="toolbox__content--images">
            <div class="toolbox--first-bock programmarchiv">
              <img src="assets/images/IMG_6675.png" alt="">
            </div>
            <div class="toolbox--first-bock programmarchiv">
              <div>
                <img src="assets/images/Programmarchiv.jpg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="toolbox" (click)="router.navigate(['/about-us'])">
    <div class="toolbox__content">
      <div class="heading ">Über uns</div>
      <div class="toolbox__content--images">
        <div class="toolbox--first-bock">
          <img src="assets/images/Teamfoto-min.jpg" alt="">
        </div>
        <div class="toolbox--second-block">
          <div><img src="assets/images/transform-min.jpg" alt="Wemen in the sport room"></div>
        </div>
      </div>
    </div>
  </section>
</div>
